import translate from "../locales";

export function Progress({ onBackButton, step, title }) {
  if (step === undefined) return null;

  return (
    <div className="progress">
      {step > 1 && (
        <button className="progress__back" onClick={onBackButton}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="progress__back-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-label={translate("general.prev_page_aria")}
          >
            <path d="M10 18L4 12L10 6L11.4 7.45L7.85 11H20V13H7.85L11.4 16.55L10 18Z" />
          </svg>
        </button>
      )}
      <p className="progress__title">{title}</p>
      <p className="progress__step">{step}/6</p>
    </div>
  );
}
